import React from 'react'
import Layout from '../components/layout'
import Styled from 'styled-components'
import utils from './../../scripts/utils'

import Example from '../components/example'
import ComponentProps from '../components/component-props'
import Subcomponents from '../components/subcomponents'

const camelToSpaced = utils.camelToSpaced

export default (data) => {
    const {
      name,
      examples,
      description,
      props,
      subcomponents
    } = data.pathContext.componentData

    return (
        <Layout>
            <h1>{camelToSpaced(name)}</h1>
            <ComponentDescription dangerouslySetInnerHTML={{ __html: description.contents }} />
            <ComponentDetails>
                {
                    examples && examples.length > 0 ? examples.map(function(example, idx) {
                        return <Example key={idx} example={example} />
                    }) : 'This component does not have any examples, yet.'
                }

                { props && <ComponentProps componentName={camelToSpaced(name)} propsData={props} /> }
                { subcomponents && subcomponents.length > 0 && <Subcomponents name={name} subcomponents={subcomponents} />}
            </ComponentDetails>
        </Layout>
    )
}

const ComponentDescription = Styled.p`
    font-size: 1.1rem;
`

const ComponentDetails = Styled.section`
  > h1, > h2, > h3, > h4, > h5, > h6 {
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;
    font-weight: 600;
  }

  > h1 {
    margin-bottom: 30px;
  }

  > h2 {
      font-size: 24px;
      letter-spacing: 0;
  }
`
